type SeeqLogoWhiteProps = {
  className?: string;
  onClick?: () => void;
  src: string;
  width: number;
};

export const SeeqLogo2026 = ({ className, onClick, src, width }: SeeqLogoWhiteProps) => {
  return <img className={className} src={src} height={28} width={width} onClick={onClick} data-testid="headerImage" />;
};
